module.exports = __webpack_public_path__ + "live_detail_type_2-8a275757.gif";